<template>
  <div>
    <!--    <nav-bar class="home-nav">-->
    <!--      <div slot="left" @click="onClickLeft">返回</div>-->
    <!--      <div slot="center">场馆管理()</div>-->
    <!--    </nav-bar>-->
    <!--    &lt;!&ndash;    <h1>{{ time1 }}</h1>&ndash;&gt;-->
    <!--    &lt;!&ndash;    <h1>{{ time2 }}</h1>&ndash;&gt;-->
    <!--&lt;!&ndash;    <button @click="dateTest">测试</button>&ndash;&gt;-->
    <!--    <van-row style="margin-top: 50px;">-->
    <!--      <van-col span="8"></van-col>-->
    <!--      <van-col span="8">-->
    <!--        <div style="border: dodgerblue solid 5px;padding: 5px" class="qrcode" ref="qrCodeUrl"></div>-->
    <!--      </van-col>-->
    <!--      <van-col span="8"></van-col>-->
    <!--    </van-row>-->
    <keep-alive exclude="VenueQrCode">
      <!--    <keep-alive>-->
      <router-view></router-view>
    </keep-alive>
  </div>

</template>

<script>

export default {
  name: "VenueManage",
  data() {
    return {
      time1: 1,
      time2: 1,
    }
  },
  mounted() {
    // this.creatQrCode();
  },
  methods: {
    creatQrCode() {
      let ua = navigator.userAgent.toLowerCase();
      let isIos = (ua.indexOf('iphone') != -1) || (ua.indexOf('ipad') != -1);
      let isWeixin = ua.indexOf('micromessenger') != -1;//判断是否是微信浏览器，是则是true
      // console.log(navigator);
      // console.log(ua);
      // console.log(isIos);
      // console.log(isWeixin);

    },
    dateTest() {
      let d1 = new Date(2020, 7, 10, 0, 0, 0);
      let d2 = new Date(2020, 7, 22, 0, 0, 0);
      // console.log(d1.getDate());
      // console.log(d2.getDate());
      // console.log((d2.getTime() - d1.getTime()) / (1000 * 60 * 60 * 24 * 1));

      // let t1 = d.getFullYear() + " " + d.getMonth() + " " + d.getDate() + " " + d.getHours() + " " + d.getMinutes() + " " + d.getSeconds()
      // let t2 = d.getFullYear() + " " + d2.getMonth() + " " + d2.getDate() + " " + d2.getHours() + " " + d2.getMinutes() + " " + d2.getSeconds()
      // console.log(t1);
      // console.log(t2);
      this.time1 = d1.getTime();
      this.time2 = d2.getTime();

    },
    onClickLeft() {
      this.$router.replace("/home");
    },
  }

}
</script>

<style scoped>
.qrcode {
  display: inline-block;
}

img {
  width: 132px;
  height: 132px;
  background-color: #fff;
  padding: 6px;
  /*利用padding的特性，挤出白边*/
  box-sizing: border-box;
}
</style>
